(function ($) {
  $(document).ready(function () {
    $(
      ".list-type-asaddresssearch_addresssearch .modal_address.in .modal-body > div"
    ).matchHeight();

    $('.tx-as-address-search input[type="reset"]').click(function () {
      $(".tx-as-address-search select").each(function () {
        $(this).val("");
      });
      $('.tx-as-address-search input[type="text"]').val("");
      $(".tx-as-address-search form").trigger("submit");
    });

    $(".tx-as-address-search form").on("submit", function (event) {
      var $listPlugin = $(".tx-as-address-search .search-result").parents(
        ".list-type-asaddresssearch_addresssearch"
      );
      $listPlugin.LoadingOverlay("show");
      $("html, body").animate(
        {
          scrollTop:
            $(".tx-as-address-search .search-result")
              .parents(".list-type-asaddresssearch_addresssearch")
              .offset().top - 101,
        },
        1000
      );
      $.ajax({
        type: "POST",
        url: $(this).attr("action"),
        data: $(this).serialize(),
        success: function (htmlResponse) {
          if (htmlResponse) {
            $listPlugin
              .replaceWith(htmlResponse)
              .imagesLoaded()
              .then(function () {
                // Match heights of all teasers
                $(".teaser .teaser__photo-container").matchHeight();
                $(".teaser .teaser__desc-container").matchHeight();
                $(".teaser .teaser__more-link-container").matchHeight();
                $(".search-result .teaser").matchHeight();
              });
            // Activate pagination again
            activatePagination();
          }
        },
      });
      event.preventDefault();
    });

    activatePagination();
  });

  var activatePagination = function () {
    $(".tx-as-address-search .pagination li a").each(function () {
      $(this).unbind("click");
      $(this).click(function (event) {
        var $listPlugin = $(".tx-as-address-search .search-result").parents(
          ".list-type-asaddresssearch_addresssearch"
        );
        $listPlugin.LoadingOverlay("show");
        $("html, body").animate(
          {
            scrollTop:
              $(".tx-as-address-search .search-result")
                .parents(".list-type-asaddresssearch_addresssearch")
                .offset().top - 101,
          },
          1000
        );
        $.ajax({
          type: "POST",
          url: $(this).data("link"),
          data: $(".tx-as-address-search form").serialize(),
          success: function (htmlResponse) {
            if (htmlResponse) {
              $listPlugin
                .replaceWith(htmlResponse)
                .imagesLoaded()
                .then(function () {
                  // Match heights of all teasers
                  $(".teaser .teaser__photo-container").matchHeight();
                  $(".teaser .teaser__desc-container").matchHeight();
                  $(".teaser .teaser__more-link-container").matchHeight();
                  $(".search-result .teaser").matchHeight();
                });
              // Activate pagination again
              activatePagination();
            }
          },
        });
        event.preventDefault();
      });
    });
  };

  // Fn to allow an event to fire after all images are loaded
  $.fn.imagesLoaded = function () {
    // get all the images (excluding those with no src attribute)
    var $imgs = this.find('img[src!=""]');
    // if there's no images, just return an already resolved promise
    if (!$imgs.length) {
      return $.Deferred().resolve().promise();
    }

    // for each image, add a deferred object to the array which resolves when the image is loaded (or if loading fails)
    var dfds = [];
    $imgs.each(function () {
      var dfd = $.Deferred();
      dfds.push(dfd);
      var img = new Image();
      img.onload = function () {
        dfd.resolve();
      };
      img.onerror = function () {
        dfd.resolve();
      };
      img.src = this.src;
    });

    // return a master promise object which will resolve when all the deferred objects have resolved
    // IE - when all the images are loaded
    return $.when.apply($, dfds);
  };
})(jQuery);
